import * as React from "react";
import { useDispatch } from "react-redux";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { getAuthCredentails, verifyAuthCredentails } from "../../utils";
import { setAuthToken } from "../../actions";
import CustomizedSnackbars from "../Shared/SnackBar";
import styled from "styled-components";




  const LoginContainer = styled.div`
  
    margin-left: 1rem;
   
    min-width: 371px;
    

@media (max-width: 761px) {
      width: 100%;
      margin-left: 0rem;


  .signup-inner-div {
  
    width: 100%;
   
  }
}`;

  const LoginHeader = styled.div`
    font-size: 1rem;
    font-weight: 400;
   
    color:rgb(40, 40, 40);
    text-align:left;
    margin-right:auto;
    width:100%;
    margin-left:1rem;


    @media (max-width: 761px) {
  margin-left:unset;
  
  }
  
  `;
  
  const LoginInnerCont = styled.div`
    padding: 0rem 1rem 1rem 1rem;
    width:421px;
  
    @media (max-width: 761px) {
  padding: 0rem 2rem 0rem 0rem;
  width:100%;
  
  }
  `;
  
  const StyledGrid = styled(Grid)`
    && {
      margin-bottom: 11px;
    }
  `;
  
  const StyledButton = styled.div`
  
  border-radius:5rem;
  height:45px;
  background-color:#fb641c;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor:pointer;
    && {
      color: white;
      margin-top: 1rem;
    }
  `;
  
  const StyledLink = styled(Link)`
    color:rgb(19, 129, 240);
    text-decoration: none;
    font-size: 1.1rem;
    &:hover {
      text-decoration: underline;
    }
  `;
  
  const StyledInput = styled.input`
    color:rgb(35, 35, 35);
    text-decoration: none;
    outline:none;
    border-radius:44px;
    width:100%;
    height:45px;
    margin-top:1rem;
    padding:.6rem;
    border:1px solid #999;
    font-size:.9rem;
    padding-left:1rem;
    font-size: 0.95rem;
  
    &:hover {
      text-decoration: underline;
    }
  `;

  const StyledInputNew = styled.input`
  width: 100%;
  padding: 12px;
  margin: 8px 0;
  box-sizing: border-box;
  outline:none;
  border-radius:111px;
  border:1px solid #333;
  margin-top:1rem;
`;

export default function SignUp() {
  const dispatch = useDispatch();
  const [requestNumber, setRequestNumber] = React.useState("");
  const [otpData, setOtpData] = React.useState("");
  const [alertOpen, setAlertOpen] = React.useState({
    isAlert: false,
    msg: "",
    type: "",
  });
  const [enableOTP, setEnableOTP] = React.useState(false);

  const handleRequestEmailOrPhone = (e) => {
    
/*     if (alertOpen?.isAlert) {
      setAlertOpen({ isAlert: false, msg: "", type: "" });
    }
    if (enableOTP) {
      setEnableOTP(false);
    } */
    const value = e.target.value;
    setRequestNumber(value);
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    const opt = e.target.value;
    setOtpData(opt);
  };

  const submitVerifyOtp = async () => {
    const requestOptData = otpData;
    const requestEmailorMobile = requestNumber;

    const verifyOtpResponse = await verifyAuthCredentails({
      emailID: requestEmailorMobile,
      type: "signup",
      userOTP: requestOptData,
    });
    const { data = "", status = 100 } = verifyOtpResponse;
    if (status === 200) {
      localStorage.setItem("userToken", JSON.stringify(data));
      if (window !== undefined) {
        window.location.href = "/";
      }
    } else {
      setAlertOpen({
        isAlert: true,
        msg: `Something went wrong, try again`,
        type: "error",
      });
    }
  };

  const verifyEmailAddress = async () => {
    const mobileOrEmail = requestNumber;
    const regexForPhone = /^([+]\d{2})?\d{10}$/;
    const regexForEmail =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (
      mobileOrEmail.match(regexForPhone) ||
      mobileOrEmail.match(regexForEmail)
    ) {
      const validateEmail = await getAuthCredentails({
        emailID: mobileOrEmail,
        type: "signup",
      });
      const { data = "", response = "", status = 0 } = validateEmail;
      const { data: { status: errorStatus = 100, errorMessage = "" } = {} } =
        response;
      if (status === 200) {
        dispatch(setAuthToken(data));
        setAlertOpen({ isAlert: false, msg: "", type: "" });
        setEnableOTP(true);
      } else if (
        errorStatus === 400 &&
        errorMessage === "User already exists!"
      ) {
        setAlertOpen({
          isAlert: true,
          msg: `${errorMessage}, try login`,
          type: "error",
        });
      }
    } else {
      setAlertOpen({ isAlert: true, msg: "Invalid Email", type: "error" });
      console.log("not valid email");
    }
  };





  return (
    <React.Fragment>
      <LoginContainer
      
     
      >
    <div className="signup-inner-div" style={{marginTop:'1rem',maxHeight:'fit-content',marginLeft:'1rem'}}>
   
         <LoginHeader>Sign Up</LoginHeader>
          <LoginInnerCont>
          {!enableOTP && ( <><StyledInputNew
        type="text"
        value={requestNumber}
        onChange={(e) => setRequestNumber(e.target.value)}
        placeholder="Enter email address..."
      />
      </>

)}
           {enableOTP && (
           <>
            <div style={{marginTop:'1rem'}}>
              Enter otp
            </div>
              <StyledInput
                margin="normal"
                type="number"
                required
                key={'signup-email-input'}
                size="small"
                fullWidth
                name="otp"
                label="Enter OTP"
                placeholder="otp recived on your email address..."
                id="otp"
                onChange={handleVerifyOTP}
                disabled={!enableOTP}
                autoComplete="none"
              /></>
            )}

          
            {!enableOTP && (
              <StyledButton
                type="submit"
                id="OTPRequest"
                fullWidth
                size="small"
                name="OTPRequest"
                variant="contained"
                onClick={verifyEmailAddress}
                color="login"
                sx={{ color: "white" }}
                style={{textAlign:'left'}}
              >
                Sign Up
              </StyledButton>
            )}
            {enableOTP && (
              <StyledButton
                type="submit"
                id="OTPRequest"
                fullWidth
                size="small"
                name="OTPRequest"
                variant="contained"
                onClick={submitVerifyOtp}
                color="login"
                sx={{ color: "white" }}
              >
                Verify
              </StyledButton>
            )}
          
         
          
             <div style={{marginTop:'1rem'}}>
               <Link style={{color:'rgb(19, 129, 240)',marginTop:'.5rem'}} to="/login">{"login"}</Link>
             </div>
          
            {enableOTP && (
            
                <Link onClick={verifyEmailAddress}>{"Request Again? "}</Link>
          
            )}
          
              {alertOpen?.isAlert && (
                <CustomizedSnackbars
                  text={alertOpen?.msg}
                  isOpen={alertOpen?.isAlert}
                  type={alertOpen?.type}
                />
              )}
          
          </LoginInnerCont>
        
    </div>
      </LoginContainer>
    </React.Fragment>
  );
}
